class EventsMetrics {
  constructor() {
    this.deliveryTarget = 100;
    this.cupsTarget = 56600;
    this.businessesTarget = 432;
    
    // Growth increments
    this.cupsIncrements = [250, 500, 1000, 2000, 3000];
    this.businessIncrements = [1, 2];
    
    // Storage keys for localStorage
    this.cupsKey = 'events_cups_count';
    this.businessesKey = 'events_businesses_count';
    this.lastUpdateKey = 'events_last_update';
    
    this.init();
  }
  
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.startMetrics());
    } else {
      this.startMetrics();
    }
  }
  
  startMetrics() {
    // Check if metrics section exists
    const metricsSection = document.querySelector('.events-metrics-section');
    if (!metricsSection) return;
    
    // Update growing metrics based on time
    this.updateGrowingMetrics();
    
    // Start animations for desktop metrics
    this.animateCounter('metric-delivery', this.deliveryTarget, '%', 2000);
    this.animateCounter('metric-cups', this.getStoredCupsCount(), '+', 2500);
    this.animateCounter('metric-businesses', this.getStoredBusinessesCount(), '+', 2200);
    
    // Start animations for mobile metrics
    this.animateCounter('metric-delivery-mobile', this.deliveryTarget, '%', 2000);
    this.animateCounter('metric-cups-mobile', this.getStoredCupsCount(), '+', 2500);
    this.animateCounter('metric-businesses-mobile', this.getStoredBusinessesCount(), '+', 2200);
    
    // Set up weekly growth intervals
    this.setupGrowthIntervals();
  }
  
  getStoredCupsCount() {
    const stored = localStorage.getItem(this.cupsKey);
    return stored ? parseInt(stored, 10) : this.cupsTarget;
  }
  
  getStoredBusinessesCount() {
    const stored = localStorage.getItem(this.businessesKey);
    return stored ? parseInt(stored, 10) : this.businessesTarget;
  }
  
  getLastUpdateTime() {
    const stored = localStorage.getItem(this.lastUpdateKey);
    return stored ? parseInt(stored, 10) : Date.now();
  }
  
  updateGrowingMetrics() {
    const now = Date.now();
    const lastUpdate = this.getLastUpdateTime();
    const weekInMs = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds
    
    // Check if a week has passed
    if (now - lastUpdate >= weekInMs) {
      const weeksElapsed = Math.floor((now - lastUpdate) / weekInMs);
      
      // Update cups count
      let currentCups = this.getStoredCupsCount();
      for (let i = 0; i < weeksElapsed; i++) {
        const randomIncrement = this.cupsIncrements[Math.floor(Math.random() * this.cupsIncrements.length)];
        currentCups += randomIncrement;
      }
      localStorage.setItem(this.cupsKey, currentCups.toString());
      
      // Update businesses count
      let currentBusinesses = this.getStoredBusinessesCount();
      for (let i = 0; i < weeksElapsed; i++) {
        const randomIncrement = this.businessIncrements[Math.floor(Math.random() * this.businessIncrements.length)];
        currentBusinesses += randomIncrement;
      }
      localStorage.setItem(this.businessesKey, currentBusinesses.toString());
      
      // Update last update time
      localStorage.setItem(this.lastUpdateKey, now.toString());
    }
  }
  
  setupGrowthIntervals() {
    // Growth happens every week in real time
    // But we'll also simulate smaller increments for demo purposes
    // Uncomment below for testing (grows every 10 seconds)
    /*
    setInterval(() => {
      this.simulateWeeklyGrowth();
    }, 10000);
    */
  }
  
  simulateWeeklyGrowth() {
    // This is for testing purposes - simulates weekly growth every 10 seconds
    const currentCups = this.getStoredCupsCount();
    const currentBusinesses = this.getStoredBusinessesCount();
    
    const cupsIncrement = this.cupsIncrements[Math.floor(Math.random() * this.cupsIncrements.length)];
    const businessIncrement = this.businessIncrements[Math.floor(Math.random() * this.businessIncrements.length)];
    
    const newCups = currentCups + cupsIncrement;
    const newBusinesses = currentBusinesses + businessIncrement;
    
    localStorage.setItem(this.cupsKey, newCups.toString());
    localStorage.setItem(this.businessesKey, newBusinesses.toString());
    localStorage.setItem(this.lastUpdateKey, Date.now().toString());
    
    // Update the display for both desktop and mobile
    this.animateCounter('metric-cups', newCups, '+', 1000);
    this.animateCounter('metric-businesses', newBusinesses, '+', 1000);
    this.animateCounter('metric-cups-mobile', newCups, '+', 1000);
    this.animateCounter('metric-businesses-mobile', newBusinesses, '+', 1000);
  }
  
  animateCounter(elementId, target, suffix, duration) {
    const element = document.getElementById(elementId);
    if (!element) return;
    
    const start = 0;
    const increment = target / (duration / 16); // 60fps
    let current = start;
    
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(timer);
      }
      
      const formattedNumber = this.formatNumber(Math.floor(current));
      element.textContent = formattedNumber + suffix;
    }, 16);
  }
  
  formatNumber(num) {
    if (num >= 1000) {
      return num.toLocaleString();
    }
    return num.toString();
  }
}

// Initialize when script loads
new EventsMetrics(); 